import React, { useContext } from 'react';

import { ApplicationUIContext, SummaryCard } from '@yuhuinc/ui-library';
import { Typography, List, Row } from 'antd';

import { getTranslatedString } from 'helpers/i18n';

import { CurrentApplicationContext } from '../../ApplicationOverview';

import ApplicantStatus from '../../common/ApplicantStatus';

const { Title } = Typography;

const Applicants = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const application = useContext(CurrentApplicationContext);

  const consentChecksText = getTranslatedString(
    'landlordPortal.applicationManagement.applicationOverview.overview.applicants.consentChecks'
  );
  const creditCheckText = getTranslatedString(
    'landlordPortal.applicationManagement.applicationOverview.overview.applicants.creditCheck'
  );
  const criminalCheckText = getTranslatedString(
    'landlordPortal.applicationManagement.applicationOverview.overview.applicants.criminalCheck'
  );
  const incomeDocumentationText = getTranslatedString(
    'landlordPortal.applicationManagement.applicationOverview.overview.applicants.incomeDocumentation'
  );
  const referencesProvidedText = getTranslatedString(
    'landlordPortal.applicationManagement.applicationOverview.overview.applicants.referencesProvided'
  );

  return (
    <>
      <Title level={isMobile ? 4 : 5}>
        {getTranslatedString(
          'landlordPortal.applicationManagement.applicationOverview.overview.applicants'
        )}
      </Title>

      <List
        grid={{
          gutter: 16,
          column: isMobile ? 1 : 3,
        }}
        dataSource={application.cotenants}
        renderItem={(cotenant) => (
          <List.Item>
            <SummaryCard
              heading={cotenant.full_name}
              subheading={
                <Row justify="space-between">
                  {getTranslatedString(
                    `landlordPortal.applicationManagement.applicationOverview.overview.applicants.applicantTypes.${cotenant.applicant_type}`
                  )}
                  <ApplicantStatus applicant={cotenant} />
                </Row>
              }
            >
              <SummaryCard.Item
                label={consentChecksText}
                buttonText={
                  cotenant.credit_check_consent
                    ? getTranslatedString('yes')
                    : getTranslatedString('no')
                }
              />
              <SummaryCard.Item label={creditCheckText} buttonText="-" />
              <SummaryCard.Item label={criminalCheckText} buttonText="-" />
              <SummaryCard.Item label={incomeDocumentationText} buttonText="-" />
              <SummaryCard.Item
                label={referencesProvidedText}
                buttonText={
                  cotenant.landlord_references.length > 0 ? getTranslatedString('completed') : '-'
                }
              />
            </SummaryCard>
          </List.Item>
        )}
      />
    </>
  );
};

export default Applicants;
